import '@strongdm/design-system/lib/index.css'
import 'normalize.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { LoginPage } from './LoginPage/LoginPage'
;(() => {
  const root = document.getElementById('root')
  if (!root) return

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <LoginPage />
    </React.StrictMode>,
  )
})()
